import React, {useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopSchoolReport from './_PopSchoolReport';
function SchoolReport() {
  
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '미작성', value: 0},
    {title: '내 수시 보고서', value: 1}
  ];
  const [modalSchoolReport, setModalSchoolReport] = useState(false);
  return (
    <main className="com_container p_school_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_13">수시 보고서</h2>
          <button onClick={() => setModalSchoolReport(true)} className="com_btn orange s btn_plus">
            수시 보고서 작성
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search end">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                </div>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">논술</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">생기부디자인</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">정시컨설팅</label>
                  <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">수시컨설팅</label>
                  <input type="radio" name="rdo" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">면접</label>
                  <input type="radio" name="rdo" id="rdo07" className="com_chk circle" />
                  <label htmlFor="rdo07">자소서</label>
                </div>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="70" />
                <col width="120" />
                <col width="120" />
                <col width="120" />
                <col width="120" />
                <col width="120" />
                <col width="120" />
                <col width="180" />
                <col width="90" />
                <col width="120" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>과목 명</th>
                  <th>메인 교사</th>
                  <th>서브 교사</th>
                  <th>최근수업일</th>
                  <th>회차</th>
                  <th>보고서</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td><span className='com_red_txt'>미작성</span></td>
                  <td>
                    <button className="btn_link">김학생103</button>
                  </td>
                  <td>논술</td>
                  <td></td>
                  <td>
                    <button className="btn_link">김교사103</button>
                  </td>
                  <td>
                    <button className="btn_link">김교사103</button>
                  </td>
                  <td>23.11.21 150일</td>
                  <td><button className="btn_link">1/2</button></td>
                  <td>
                    <button className="btn_link red">미작성</button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 2}</td>
                      <td>2023. 05. 06</td>
                      <td>
                        <button className="btn_link">김학생103</button>
                      </td>
                      <td>논술</td>
                      <td></td>
                      <td>
                        <button className="btn_link">김교사103</button>
                      </td>
                      <td>
                        <button className="btn_link">김교사103</button>
                      </td>
                      <td>23.11.21 150일</td>
                      <td>
                        <button className="btn_link">1/2</button>
                      </td>
                      <td className="td_point">3</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">수시 보고서 상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <button className="btn_down">전체 다운로드</button>
              </div>
            </div>
            <div className="com_board_box">
              <ReportSet time="1"/>
              <ReportSet time="2"/>
            </div>
          </section>
        </section>
        <PopSchoolReport open={modalSchoolReport} close={() => setModalSchoolReport(false)} />
      </div>
    </main>
  );
}
const ReportSet = (props) => {//보고서
  const [openDetail, setOpenDetail] = useState(false);
  const [openDetailBtn, setOpenDetailBtn] = useState(true);
  const detailClick = event => {
    setOpenDetail(current => !current);
    setOpenDetailBtn(current => !current);
  }
  return(
    <>
    <div className="board_item">
      <div className="com_detail_top">
        <button className="state">{props.time}차 보고서</button>
        <div className="info center">
          <p className="tit">생기부 디자인 컨설팅 (제안) 보고서</p>
        </div>
      </div>
      <div className="info">
        <span className="cont">
          <button className="name">홍학생102 </button>
          <span className="desc dot">수업일 : 2023, 05, 16 15:30</span>
        </span>
      </div>
      <div className="info">
        <span className="cont">
          <button className="name">홍학생102 </button>
          <span className="desc dot">수업일 : 2023, 05, 16 15:30</span>
        </span>
      </div>
      <button
        type="button"
        className={`icon_arrow_down ${openDetailBtn ? "active" : ""}`}
        onClick={() => {
          detailClick();
        }}
      ></button>
      {openDetail ? (
        <div className="detail">
          <hr className="com_divider" />
          <div className="inner">
            <p className="txt">
              생기부 디자인 컨설팅 파일명 파일명 파일명 <button className="btn_down" />
            </p>
            <p className="txt">
              생기부 디자인 컨설팅 파일명 파일명 파일명 <button className="btn_down" />
            </p>
          </div>
          <hr className="com_divider" />
          <div className="inner">
            <p className="txt bold">생기부디자인 컨설팅(제안) 보고서</p>
            <p className="desc">Extracumicular axtivities design report1</p>
            <table className="com_board_list">
              <colgroup>
                <col width="50px" />
                <col width="20%" />
                <col />
                <col width="20%" />
              </colgroup>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>모집기관</th>
                  <th>상세 내용</th>
                  <th>연락처</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowSpan={4}>봉사활동</td>
                  <td>
                    훼밀리데이
                    <br />
                    케어센터
                  </td>
                  <td className="td_left">
                    어르신케어, 청소, 어르신 이동 <br />
                    도움 등<br />
                    모집 기간: ~2020.03.31
                    <br />
                    봉사 기간: ~2020.03.31
                  </td>
                  <td>02-400-9506</td>
                </tr>
                <tr>
                  <td className="border_left">KB골든라이프케어 위례 케어센터</td>
                  <td className="td_left">
                    어르신케어, 청소, 어르신 이동 <br />
                    도움 등<br />
                    모집 기간: ~2020.03.31
                    <br />
                    봉사 기간: ~2020.03.31
                  </td>
                  <td>02-6412-4827</td>
                </tr>
                <tr>
                  <td className="border_left">
                    의정부시
                    <br />
                    장애인종합복지관
                  </td>
                  <td className="td_left">
                    고1 남학생 수학 학습 지원
                    <br />
                    모집 기간: ~2020.03.31
                    <br />
                    봉사 기간: 2020.04.01.~
                    <br />
                    2020.07.01
                  </td>
                  <td>031-850-5381</td>
                </tr>
                <tr>
                  <td className="border_left">
                    안양시자원
                    <br />
                    봉사센터
                  </td>
                  <td className="td_left">
                    마스크키트로 교체필터용 <br />
                    면 마스크 제작
                    <br />
                    모집 기간: ~2020.03.31
                    <br />
                    봉사 기간: ~2020.03.31
                  </td>
                  <td>031-8045-2487</td>
                </tr>
              </tbody>
            </table>
            <div className="notice">
              <p className="tit bold">【 선생님의 말 】</p>
              <p className="txt">대학은 봉사 활동 기록을 통해 학생의 공동체 의식이나 희생정신, 배려와 나눔의 태도, 사회적 감수성 등 인성 요소를 평가합니다. 교내에서 이루어지는 단순 활동보다는 교과 및 진로희망과 연계된 외부활동을 적극적으로 참여하는 편이 좋은 평가를 받는 데 유리합니다. 봉사활동을 선택하는 데 개인적 동기(사회적 문제의식, 사회적 책임감)가 발현되어 이루어지는 것이 가장 좋습니다.</p>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
    </>
  )
}
export default SchoolReport;
